import React from 'react';
import {connect} from 'react-redux';
import {I18n} from 'react-redux-i18n';
import Grid from '@material-ui/core/Grid';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import Menu from '@material-ui/core/Menu';
import ListItemText from '@material-ui/core/ListItemText';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';
import Button from '@material-ui/core/Button';
import CircularProgress from '@material-ui/core/CircularProgress';
import Icon from '@material-ui/core/Icon';
import {get, set, isEqual} from 'lodash';
import momentTimezone from 'moment-timezone';
import ProgressSpinner from '../../Loading/ProgressSpinner';
import moment from '../../util/moment';
import Filters from '../filters/ReportFilterBar';
import SummaryReport from '../component/SummaryReport';
import DriverReport from '../component/DriverReport';
import DriverDetailsReport from '../component/DriverDetailsReport';
import FileDownloader from '../../app/FileDownloader';
import {
  loadSummaryReport,
  loadDriverReport,
  loadDetailsReport,
  downloadReport,
  goToPlayer,
  reset
} from '../ReportActions';
import {setChips, setDates, clear, setReportType} from '../filters/ReportFiltersActions';

import ReportTypes,
{
  SUMMARY_BY_DRIVER_REPORT,
  SUMMARY_DRIVER_DETAIL_REPORT,
  ADMIN_REPORT
} from '../ReportTypes';

class Report extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      downloadElement: null,
      downloadOpen: false
    };
  }

  componentWillMount() {
    this.updateReport();
  }

  componentDidUpdate(prevProps) {
    const filtersIsEqual = isEqual(prevProps.filters.applied, this.props.filters.applied);
    if (!filtersIsEqual) {
      this.updateReport(this.props.filters.applied);
    }
  }

  componentWillUnmount() {
    this.props.reset();
    this.props.clear();
  }

  getFilters = (filters = this.props.filters.applied) => {
    const customerData = get(this.props, 'customer.data', null);
    const useTerminal = get(customerData, 'settings.useTerminal', false);

    set(filters, 'terminalRestriction', useTerminal);
    set(filters, 'timezone', momentTimezone.tz.guess());

    return filters;
  }

  handleClickDownload = event => {
    this.setState({downloadElement: event.currentTarget, downloadOpen: true});
  };

  handleCloseDownload = () => {
    this.setState({downloadElement: null, downloadOpen: false});
  };

  handleAddFilterDate = key => () => {
    const clearDate = key.replace(/-/g, '/');
    const month = clearDate.split('/')[0];
    const date = moment(new Date(clearDate.replace(month, moment().month(month).format('M'))));

    this.props.setReportType({reportSelected: SUMMARY_BY_DRIVER_REPORT});
    this.props.setDates(date.toDate().getTime(), date.toDate().getTime());
  };

  handleAddFilterDriver = (driverId, driverName) => () => {
    this.props.setReportType({reportSelected: SUMMARY_DRIVER_DETAIL_REPORT});
    this.props.setChips([{name: 'driver', label: driverName, id: driverId}]);
  };

  handleRedirectMedia = mediaId => () => {
    this.props.goToPlayer(mediaId);
  };

  handleClickDownloadReport = reportType => () => {
    const filters = this.getFilters();

    this.props.downloadReport(reportType, filters).then(report => {
      FileDownloader.forData(report).downloadAs('report.xlsx');
    });

    this.handleCloseDownload();
  };

  updateReport = (_filters = this.props.filters.applied) => {
    const filters = this.getFilters(_filters);
    const {reportSelected} = _filters;

    const reportType = ReportTypes.get(reportSelected);
    if (reportType.isSummaryByDriver()) {
      this.props.loadDriverReport(filters);
    } else if (reportType.isSummaryDriverDetail()) {
      this.props.loadDetailsReport(filters);
    } else {
      this.props.loadSummaryReport(filters);
    }
  };

  handleChangeReport = event => {
    const reportTypeKey = get(event, 'target.value');
    const reportType = ReportTypes.get(reportTypeKey);
    this.props.setReportType({reportSelected: reportType});
  };
  getIntelliview = () => {
    let intelliview = get(this.props, 'customer.data.intelliview', null);
    intelliview = intelliview ?
      {
        showPrimary: intelliview.enabled && intelliview.eventTypes.length > 0,
        showSecondary: intelliview.enabled && intelliview.secondaryVideos.length > 0
      } :
      {
        showPrimary: false,
        showSecondary: false
      };
    return intelliview;
  }
  render() {
    const reportTypes = ReportTypes.selectableReports();
    const {report} = this.props;
    const {reportSelected: reportKey} = this.props.filters.applied;
    const reportSelected = ReportTypes.get(reportKey);
    const intelliview = this.getIntelliview();
    const {
      downloadElement,
      downloadOpen
    } = this.state;
    
    return (
      <div>
        <Grid container direction="row" className="reports__filter-container">
          <Grid item lg={2} md={3} sm={12} xs={12} className="reports__filter-cont">
            <FormControl className="reports__filter-cont-select">
              <InputLabel htmlFor="selectReport">{I18n.t('page.reports.selectReport')}</InputLabel>
              <Select
                id="selectReport"
                MenuProps={{id: 'selectReportMenu'}}
                onChange={this.handleChangeReport}
                value={reportSelected.key}
              >
                {reportTypes.map(reportType => (
                  <MenuItem
                    id={reportType.key}
                    key={reportType.key}
                    value={reportType.key}
                  >
                    {reportType.name}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>

            <Button
              id="downloadReportButton"
              className="btn btn-primary reports__filter-bt"
              disabled={report.isDownloadLoading}
              onClick={this.handleClickDownload}
            >
              {report.isDownloadLoading && (
                <CircularProgress className="loading__cirgularprogress" size={25} />
              )}

              {!report.isDownloadLoading && [
                <Icon key="download_icon">get_app</Icon>,
                <Icon key="dropown_icon">arrow_drop_down</Icon>
              ]}
            </Button>
            <Menu
              id="downloadReportMenu"
              anchorEl={downloadElement}
              open={Boolean(downloadOpen)}
              onClose={this.handleCloseDownload}
            >
              <MenuItem
                id="downloadCurrentReport"
                onClick={this.handleClickDownloadReport(reportSelected)}
              >
                <ListItemIcon>
                  <Icon>description</Icon>
                </ListItemIcon>
                <ListItemText primary={I18n.t('page.reports.download.currentReport')} />
              </MenuItem>
              <MenuItem
                id="downloadAdminReport"
                onClick={this.handleClickDownloadReport(ADMIN_REPORT)}
              >
                <ListItemIcon>
                  <Icon>library_books</Icon>
                </ListItemIcon>
                <ListItemText primary={I18n.t('page.reports.download.adminSummary')} />
              </MenuItem>
            </Menu>
          </Grid>
          <Grid item lg={10} md={9} sm={12} xs={12}>
            <Filters id="reportFilterBar" />
          </Grid>
        </Grid>
        <Grid container className="reports__container">
          <Grid item lg={12} md={12} sm={12} xs={12}>
            <ProgressSpinner show={report.isLoading} />
            {!report.isLoading && reportSelected.isSummaryReport() &&  (
              <SummaryReport addFilterDate={this.handleAddFilterDate} {...intelliview} {...report} locale={this.props.locale} />
            )}
            {!report.isLoading && reportSelected.isSummaryByDriver() && (
              <DriverReport addFilterDriver={this.handleAddFilterDriver} {...intelliview} {...report} locale={this.props.locale} />
            )}
            {!report.isLoading && reportSelected.isSummaryDriverDetail() && (
              <DriverDetailsReport redirectMedia={this.handleRedirectMedia} {...intelliview} {...report} locale={this.props.locale} />
            )}
          </Grid>
        </Grid>
      </div>
    );
  }
}

function mapStateToProps(state) {
  const {report, reportFilter, customer} = state;
  return {
    ...report,
    filters: reportFilter,
    customer,
    locale: state.i18n.locale
  };
}

export default connect(mapStateToProps, {
  loadSummaryReport,
  loadDriverReport,
  loadDetailsReport,
  downloadReport,
  goToPlayer,
  setChips,
  setDates,
  setReportType,
  reset,
  clear
})(Report);
